import { createStyles, FullToken } from 'antd-style'

export const useStyle = createStyles(
  (
    { token },
    props: {
      backgroundColor?: keyof FullToken
      size?: number
    }
  ) => ({
    icon: {
      borderRadius: token.sizeXXS,
      width: props?.size,
      height: props?.size,
      backgroundColor: props.backgroundColor
        ? String(token[props.backgroundColor])
        : token.colorPrimaryBg
    }
  })
)
